export default function ({ store, redirect }) {
  // If the user is not authenticated
  if (!store.state.authUser) {
    //console.log(store.state);
    let baseURL = 'https%3A%2F%2Fwtd-bof.trueid-dev.net'
    switch (process.env.DMPENV) {
      case 'prod-ocp4':
        baseURL = 'https%3A%2F%2Fwtd-bof.trueid.net';
        break;
      case 'alpha-ocp4':
        baseURL='https%3A%2F%2Fwtd-bof.trueid-alpha.net';
        break;
      case 'preprod-ocp4':
        baseURL='https%3A%2F%2Fwtd-bof.trueid-preprod.net'
        break;
      default:
        break;
    }
    //console.log(baseURL)
    let path = `https://accounts.trueid.net/signin?client_id=1571&redirect_uri=${baseURL}&state=home`;
    return redirect(path)
  }
}
